const { getElement } = window.BAO.Utils

export class SiteDrawer extends window.BAO.CustomElement({
  SuperClass: HTMLDialogElement,
}) {
  constructor () {
    super()

    this.drawers = getElement('site-drawers')
    if (!this.drawers) {
      throw new Error(
        `${this.nodeName.toLowerCase()} needs a <site-drawers> element to work`,
      )
    }

    this.inert = true
    this._isOpen = false
  }

  connectedCallback () {
    super.connectedCallback()

    if (this.drawerShouldBeMoved) {
      window.setTimeout(
        () => {
          const moveToElement = this.moveToElement
          this.removeAttribute('data-module-drawers-move-me')
          moveToElement.appendChild(this)
        },
        parseInt(this.getAttribute('data-module-drawers-move-delay'), 10) || 0,
      )
    }
  }

  get key () {
    return this.getAttribute('key')
  }

  get elements () {
    return {
      trigger: getElement(`[data-drawers-trigger=${this.key}]`),
      close: getElement(`[data-module-drawers-close=${this.key}]`),
    }
  }

  get isOpen () {
    return this._isOpen
  }

  get isPopDrawer () {
    return this.classList.contains('drw-PopDrawer')
  }

  set isOpen (val) {
    this._isOpen = val

    if (this.isPopDrawer) {
      this.classList.toggle('drw-PopDrawer-active', val)
      this.inert = !val

      if (val) {
        this.show()
      } else {
        this.addEventListener('transitionend', () => this.close(), {
          once: true,
        })
      }
    } else {
      this.classList.toggle(this.config.classes.activeDrawerClass, val)

      if (val) {
        if (!this.hasAttribute('open')) {
          this.inert = false
          this.showModal()

          if (this.key === 'tagalys-quick-search') {
            setTimeout(() => {
              document.querySelector('.drw-QuickSearch_Input').focus()
            }, 500)
          }
        }
      } else {
        if (this.hasAttribute('open')) {
          this.inert = true
          this.close()
        }
      }
    }
  }

  get drawerShouldBeMoved () {
    return this.hasAttribute('data-module-drawers-move-me')
  }

  get moveToElement () {
    switch (this.getAttribute('data-module-drawers-move-me')) {
      case 'root':
        return this.drawers
      default:
        return getElement(this.getAttribute('data-module-drawers-move-me'))
    }
  }

  get config () {
    return {
      classes: {
        activeDrawerClass: 'drw-Drawer-active',
      },
    }
  }
}

customElements.define('site-drawer', SiteDrawer, { extends: 'dialog' })
